export const config = {
  apiKey: "AIzaSyD4NXkvXFvYVlytWceZYn_Yu32OJmg-6o0",
  authDomain: "fuegia-dba28.firebaseapp.com",
  databaseURL: "https://fuegia-dba28.firebaseio.com",
  projectId: "fuegia-dba28",
  storageBucket: "fuegia-dba28.appspot.com",
  messagingSenderId: "739079965167"
}

const local = 'http://localhost:5000/fuegia-dba28/us-central1/'
const on = 'https://us-central1-fuegia-dba28.cloudfunctions.net/'

const conexion = process.env.NODE_ENV === 'development' ? local : on
const online = true //activa prueba en server
export const conn = online ? on : conexion